import React from "react";
import { Dialog, GridGenerator } from "@actinc/dls";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useForm } from "react-hook-form";

import { ControlledFormSelect } from "../";

const SelectUserDialog = ({ onClose, open, users }) => {
  const { control, getValues, handleSubmit } = useForm({
    defaultValues: { user: null },
    mode: "onSubmit",
    reValidateMode: "onChange",
  });

  const handleClose = (value) => () => {
    onClose(value);
  };

  const onSubmit = () => {
    const data = getValues();
    handleClose(data.user)();
  };

  return (
    <Dialog maxWidth="sm" onClose={handleClose(false)} open={open}>
      <DialogTitle>Select User</DialogTitle>
      <DialogContent>
        <form id="selectUserForm" onSubmit={handleSubmit(onSubmit)}>
          <GridGenerator
            groups={[
              [
                {
                  children: (
                    <ControlledFormSelect
                      control={control}
                      fullWidth={true}
                      id="selectUser-user"
                      label="User"
                      name="user"
                      options={users}
                      rules={{
                        required: true,
                      }}
                    />
                  ),
                  key: "selectUser-user",
                },
              ],
            ]}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose(false)} variant="text">
          Cancel
        </Button>
        <Button
          color="primary"
          form="selectUserForm"
          type="submit"
          variant="contained"
        >
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { SelectUserDialog };
